import React from "react";
import "./Projects.css";

const Projects = (props) => {
  return (
    <>
      <div className="project_heading">MY PROJECTS</div>
      <div className="project_body">
        <div className="centr_body">
          <div className="project_link"></div>
          <div className="project_desc">
            <div className="pro_title">{props.name}</div>
            <div className="pro_details">
              {props.description}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
